import { diContainer, serviceNames } from '../diContainer/diContainer';
import SaveNewBillingAddressUseCase from './SaveNewBillingAddressUseCase';
import BillingRepository from '../repositories/BillingRepository';
import { BILLING_FORM_ERROR, PURCHASER_FORM_ERROR } from './SubmitBopisUseCase';
import SaveNewShippingAddressUseCase from './SaveNewShippingAddressUseCase';
import AddressRepository from '../repositories/AddressRepository/index';
import SaveShippingAddressUseCase from './SaveShippingAddressUseCase';
import { ADDRESS_TYPE_ID, FIELD_TYPE } from '../constants/Constants';
import Config from '../domain/entities/Config';
import AddressFormStore from '../domain/entities/AddressFormStore';
import { BILLING_FORM_ERROR_SELECTED } from './ValidateAndSubmitAddressesUseCase';
import TransactionLoadHandler, { ITransactionLoad } from './TransactionLoadHandler';

const transactionLoadUseCaseOptions: ITransactionLoad = {
  transactionLoadOptions: {
    isEnabled: false,
  },
};

class SubmitAUPostCollectionsUseCase extends TransactionLoadHandler {
  private billingRepository: BillingRepository;

  private addressRepository: AddressRepository;

  private config: Config;

  constructor() {
    super({
      shouldAwait: true,
    });
    this.billingRepository = diContainer.get(serviceNames.billingRepository);
    this.addressRepository = diContainer.get(serviceNames.addressRepository);
    this.config = diContainer.get(serviceNames.config);
  }

  public async run(): Promise<void> {
    let error: string;
    const {
      addressRepository: {
        formStore: shippingFormStore,
      },
      billingRepository: {
        formStore: billingFormStore,
      },
      transactionRepository: {
        transaction: {
          billingAddress,
          shippingAddress,
        },
      },
    } = this;

    // validate new billing address
    if (billingAddress.isNewAddress && !billingFormStore.isValid) {
      billingFormStore.setShowErrors(true);
      error = BILLING_FORM_ERROR;
    }

    // validate selected billing address
    if (!billingAddress.isNewAddress) {
      const { jsonSchemasEnabled } = this.config;
      let validationSchema;

      // if json schema enabled need to load json schema for selected billing address validation
      if (jsonSchemasEnabled) {
        await this.billingRepository.loadAddressSchema(billingAddress.attributes[FIELD_TYPE.COUNTRY_ID]);
        validationSchema = this.billingRepository.formStore.addressSchema;
      } else {
        validationSchema = {
          properties: this.config.billingAddressInputSchema,
          required: [],
        };
      }

      const isBillingAddressValid = new AddressFormStore(this.config)
        .setAddress(billingAddress)
        .validateAddressBySchema(validationSchema);

      if (!isBillingAddressValid) {
        throw new Error(BILLING_FORM_ERROR_SELECTED);
      }
    }

    if (!shippingFormStore.isValid) {
      shippingFormStore.setShowErrors(true);
      error = PURCHASER_FORM_ERROR;
    }

    if (error) {
      throw new Error(error);
    }

    const address = shippingFormStore.toAddress();

    if (shippingAddress.id && shippingAddress.attributes[FIELD_TYPE.ADDRESS_TYPE] === ADDRESS_TYPE_ID.PACKSTATION) {
      address.id = shippingAddress.id;
      await new SaveShippingAddressUseCase(address, false, transactionLoadUseCaseOptions).execute();
    } else {
      await new SaveNewShippingAddressUseCase(address, false, transactionLoadUseCaseOptions).execute();
    }

    const saveNewBillingAddressUseCase = new SaveNewBillingAddressUseCase(transactionLoadUseCaseOptions);
    await saveNewBillingAddressUseCase.execute();
  }
}

export default SubmitAUPostCollectionsUseCase;
